import { connect } from "react-redux";
import { ProcedimentoViewProps, mapDispatchToProcedimentoProps, mapStateToProcedimentoProps } from "../procedimento.controller";
import { Procedimento } from "../procedimento.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { ProcedimentoCadastro } from "./procedimento.cad";
 
export const columnsProcedimento: GridColDef[] = [
    { field: 'descricao', headerName: 'Procedimento', flex: 1 },
]

function ProcedimentoList(props: ProcedimentoViewProps) {
    const { procedimentoActions,procedimentoState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = procedimentoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = procedimentoActions
    console.log("ProcedimentoList props ",props)

    useEffect(()=>{
        if(rows.length === 0)
            read()
    },[])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        console.log("chamou handleAlterar")
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {
        return ProcedimentoCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "auto",
            width:"sm"
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Procedimentos Cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                columns={columnsProcedimento}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=>read()
                }}
                ListItemTextPrimary={(row: Procedimento) => <Typography component={"span"}>{row.descricao}</Typography>}
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToProcedimentoProps,mapDispatchToProcedimentoProps)(ProcedimentoList);
